<template>
  <!-- 新增v-if="open"為了讓他重啟時刷新狀態 -->
  <div>
    <!-- -------------------主要區塊start ----------------------->
    <section class="container search pt_10 pb_3 px_0">
      <div class="row">
        <div class="col-12">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                  type="text"
                  name="Search"
                  id="Search"
                  class="form-control"
                  v-model="keyword"
                  @keydown.enter="doSearch()"
                  placeholder="輸入姓名或身分證字號進行搜尋"
                  alt="ch"
                  style="width: 100%"
                  @input="checkKeyword"
                  @blur="checkKeyword"
                />
                <span id="searchclear" v-show="keyword" @click="cleanSearch()"
                  >清除</span
                >
              </div>
              <button
                class="btn btn-primary btn-icon"
                type="submit"
                @click.prevent="doSearch()"
              >
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <!-- 預設展示 -->
    <div v-if="isSearch == 'D'">
      <h4 class="text-green d-flex">
        <span class="pt_15 d-inline-block">戶長列表</span>
      </h4>
      <div class="mt_5 font-weight-bold">請選擇你想查詢的家庭</div>
      <div class="row mt_10" v-if="getAllHouseholderBySalesResult.length != 0">
        <div
          class="col-md-3"
          v-for="(item, i) in getAllHouseholderBySalesResult"
          :key="`group-item-${i}`"
        >
          <div class="card pt_9 px_5 pb_6 mb_10">
            <el-switch
                v-model="item.namecovermask"
                active-color="#5DC46C"
                @change=changeCoverMask(item)
                style="float:right;"
            ></el-switch>
            <strong v-if="item.namecovermask"
              class="link text-underline m-0 fz_18"
              @click="toDetail(item)"
              >{{ truncate(item.name, 12) }}</strong
            >
            <strong v-else
              class="link text-underline m-0 fz_18"
              @click="toDetail(item)"
              >{{ item.name | getMaskName }}
            </strong>
            <div class="d-flex justify-content-end mt_6">
              <Avatar
                class="mr-2"
                :gender="Number(item.sex)"
                :size="20"
                :height="20"
              />
              <strong>{{
                (item.age || item.age === 0 ? item.age : "--") + "歲"
              }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-center d-flex justify-content-center mt-5"
        colspan="6"
      >
        <div
          :class="{ 'h2w3 mt-4 section-loading': custsOfAgntIsLoading }"
        ></div>
        <h3 class="mb-3 pre-formatted">{{ this.remoteDataMessage }}</h3>
      </div>
    </div>
    <!-- 搜尋展示 -->
    <div v-else-if="isSearch == 'S'" class="mt_15">
      <h4 class="text-green d-flex">
        <span class="pt_8 d-inline-block">搜尋結果</span>
        <a class="btn btn-default px_5 py_5 ml_10" @click="cleanSearch()"
          >返回家戶列表</a
        >
      </h4>
      <div
        class="row mt_10"
        v-if="getFamilyMemberByconditionResult.length != 0"
      >
        <div
          class="col-md-3"
          v-for="(item, i) in getFamilyMemberByconditionResult"
          :key="`group-item-${i}`"
        >
          <div class="card pt_9 px_5 pb_6 mb_10">
            <h4 class="link text-underline m-0 font-24" @click="toDetail(item)">
              {{ truncate(item.name, 12) }}
            </h4>
            <div class="d-flex justify-content-end mt_6">
              <Avatar
                class="mr-2"
                :gender="Number(item.sex)"
                :size="20"
                :height="20"
              />
              <strong>{{
                (item.age || item.age === 0 ? item.age : "--") + "歲"
              }}</strong>
            </div>
            <div class="mt_5" style="height: 43px; word-break: break-all">
              <span class="font-16">{{
                addFamilyName(item.familynamelist)
              }}</span>
            </div>
            <div class="d-flex justify-content-end mt_5">
              <strong class="font-16">
                {{
                  `共${
                    item.familynamelist[0] == "(無成員)"
                      ? item.familynamelist.length
                      : item.familynamelist.length + 1
                  }人`
                }}
              </strong>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-center d-flex justify-content-center mt-5"
        colspan="6"
      >
        <div
          :class="{ 'h2w3 mt-4 section-loading': custsOfAgntIsLoading }"
        ></div>
        <h3 class="mb-3 pre-formatted mr-5">
          {{ this.remoteDataMessage }}
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getFamilyMemberBycondition,
  getFamilyMemberByConditionBnk,
  getAllHouseholderBySales,
  getFamilyMemberByCsidNo,
  getAllFamily
} from "@/service";
import Avatar from "@/desktop/components/Avatar";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import mf_Mixin from "@/desktop/views/mf/mixin";
export default {
  name: "QueryCRM",
  mixins: [ mf_Mixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    customizeList: [Object]
  },
  components: { Avatar },

  data() {
    return {
      isSearch: "D", //判斷頁面與Button( D為展示預設，S為搜尋結果)
      keyword: "", //搜尋條件
      remoteDataMessage: "'資料讀取中，請稍候...", //遠端資料訊息
      custsOfAgntIsLoading: false, //是否在搜尋中
      getAllHouseholderBySalesResult: [], //戶長列表
      getFamilyMemberByconditionResult: [], //搜尋結果
      getAllFamilyResult: []
    };
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo"])
  },
  mounted() {
    this.init();
  },
  methods: {
    moment,
    ...mapActions(["updateAllHolderSearchData", "updateQueryKeyword"]),
    async init() {
      //初始化
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      const result = await getAllHouseholderBySales(
        this.$store.state.userInfo.id,
        this.$store.getters.IsBankUser
      );
      // const result = mock__getAllHouseholderBySales;
      if (result.header && result.header.status == "200") {
        this.getAllHouseholderBySalesResult = result.data;
      } else {
        // this.$toast.info({ title: result.header.message, timeOut: "10000" });
        this.$toast.info({ title: "執行失敗", timeOut: "10000" });
      }
      this.remoteDataMessage = "無任何家戶";
      this.custsOfAgntIsLoading = false;
      this.registerHanlink(); // for 難字更新
    },
    async doSearch() {
      if (this.keyword === "") {
        this.isSearch = "D";
        this.updateAllHolderSearchData([]);
        return;
      }
      this.isSearch = "S";
      this.getFamilyMemberByconditionResult = [];
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      const result = this.$store.getters.IsBankUser
        ? await getFamilyMemberByConditionBnk(
            this.$store.state.userInfo.id,
            this.keyword
          )
        : await getFamilyMemberBycondition(
            this.$store.state.userInfo.id,
            this.keyword
          );
      // const result = mock__getFamilyMemberBycondition; //假搜尋結果(關鍵字為：小)
      if (result.header && result.header.status == "200" && result.data) {
        this.getFamilyMemberByconditionResult = result.data;
        this.updateAllHolderSearchData(result.data);
      } else {
        this.getFamilyMemberByconditionResult = [];
        this.updateAllHolderSearchData([]);
      }
      this.remoteDataMessage = "查無歸戶資訊，請確認您輸入之資料是否正確";
      this.custsOfAgntIsLoading = false;
      this.registerHanlink(); // for 難字更新
    },
    cleanSearch() {
      this.keyword = "";
      this.isSearch = "D";
      this.init();
    },
    checkKeyword() {
      this.keyword = this.checkSpecialKeyword(this.keyword);
    },
    changeCoverMask(item){
      this.getAllHouseholderBySalesResult.forEach( otherItem => {
        if(otherItem != item){
            otherItem.namecovermask = false
        }
      });
    },
    //將搜尋到的家戶成員姓名合併成字串
    addFamilyName(familyNameList) {
      let str = "";
      familyNameList.forEach((familyItem, familyIndex) => {
        str +=
          familyIndex + 1 == familyNameList.length
            ? this.truncate(familyItem, 12)
            : this.truncate(familyItem, 12) + "、";
      });
      let result = this.truncate(str, 30);
      return result[result.length - 4] == "、" &&
        result[result.length - 1] == "."
        ? result.substring(0, result.length - 4) + "..."
        : result;
    },
    toDetail(item) {
      this.$store.commit("update_queryDetailTarget", {
        is_crm: "1",
        insured_id: item.csidno,
        prod_idx: "",
        familyid: item.csidno
      });
      this.$router.push("/mf/query/queryDetail");
    }
  }
};
</script>

<style lang="scss" scoped>
#searchclear {
  position: absolute;
  right: 40px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}
.card {
  flex: 1;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 10px 20px;
  border: 1px solid #989ca2;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);

  .desc {
    vertical-align: middle;
    margin-right: 10px;
  }
}
.pre-formatted {
  white-space: pre;
}
.cardList {
  padding: 10px 20px 10px 20px;
  margin-right: 13px;
  margin-bottom: 20px;
  margin-left: 0px;
}
.cardCon {
  border-radius: 8px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #989ca2;
  background-color: #ffffff;
}
</style>
